import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.jsx";
import "styles/custom.css";
import logo from "assets/img/logo.png";
import { getCurrentInstance } from "../../config/instances";
import theme from "../../styles/theme";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    };
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    const sidebarBackground = {
      backgroundImage: "url(" + this.props.image + ")",
    };
    const instance = getCurrentInstance();
    const envColor =
      instance.env === "prod"
        ? theme.colors.warning
        : instance.env === "nonprod"
          ? theme.colors.success
          : theme.colors.primary;
    return (
      <div id="sidebar" className="sidebar" data-color={this.props.color}>
        {this.props.hasImage ? (
          <div className="sidebar-background" style={sidebarBackground} />
        ) : null}
        <div className="logo">
          <a href="/" className="simple-text">
            <div className="custom-logo">
              <img src={logo} alt="logo_image" />
            </div>
            <div
              title={`You are on ${instance.label}`}
              style={{ marginTop: "8px" }}
            >
              <div
                className="ms-font-m"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: envColor,
                    marginRight: "8px",
                    flexShrink: 0,
                  }}
                />
                {instance.label}
              </div>
            </div>
          </a>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {this.state.width <= 991 ? <AdminNavbarLinks /> : null}
            {this.props.routes.map((prop, key) => {
              if (!prop.redirect)
                return (
                  <li
                    className={
                      prop.upgrade
                        ? "active active-pro"
                        : this.activeRoute(prop.layout + prop.path)
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className={prop.icon} />
                      <div className="ms-font-sm">{prop.name}</div>
                    </NavLink>
                  </li>
                );
              return null;
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;
